module.exports = __webpack_public_path__ + "static/media/pinaza_16.ac489750.gif";